module.exports = __webpack_public_path__ + "static/media/TizetiLoaderColored.15f43482.gif";